module.exports = __webpack_public_path__ + "img/sisley-logo_black-bigger.bc30681c.svg";